// src/components/common/Select.jsx
export const Select = ({ 
  label, 
  options = [], 
  error,
  fullWidth = true,
  ...props 
}) => {
  const containerStyle = {
    marginBottom: "20px",
    width: fullWidth ? "100%" : "auto"
  };

  const labelStyle = {
    display: "block",
    fontSize: "14px",
    fontWeight: "600",
    color: "#334155",
    marginBottom: "8px"
  };

  const selectStyle = {
    width: "100%",
    padding: "12px 16px",
    fontSize: "16px",
    border: `2px solid ${error ? "#ef4444" : "#e2e8f0"}`,
    borderRadius: "8px",
    outline: "none",
    transition: "all 0.2s ease",
    backgroundColor: "#ffffff",
    cursor: "pointer",
    fontFamily: "inherit",
    boxSizing: "border-box"
  };

  const errorStyle = {
    marginTop: "6px",
    fontSize: "14px",
    color: "#ef4444"
  };

  return (
    <div style={containerStyle}>
      {label && <label style={labelStyle}>{label}</label>}
      <select
        style={selectStyle}
        onFocus={(e) => {
          e.target.style.borderColor = error ? "#ef4444" : "#00a680";
          e.target.style.boxShadow = `0 0 0 3px ${error ? "rgba(239, 68, 68, 0.1)" : "rgba(0, 166, 128, 0.1)"}`;
        }}
        onBlur={(e) => {
          e.target.style.borderColor = error ? "#ef4444" : "#e2e8f0";
          e.target.style.boxShadow = "none";
        }}
        {...props}
      >
        {options.map(opt => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      {error && <p style={errorStyle}>{error}</p>}
    </div>
  );
};